import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { tecnologia } from "./Tecnologia";
import "./Tecnologias.css";

const Tecnologias: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="tech-container-main">
            <div className="tech-grid-main">
                {tecnologia.map((categoria, index) => (
                    <motion.div 
                        key={index} 
                        className="tech-category-card"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                    >
                        <h3>{t(categoria.titulo)}</h3>
                        <div className="logo-group-grid">
                            {[...categoria.tecnologias]
                                .sort((a, b) => {
                                    if (a.nombre.includes("ISO")) return 1;
                                    if (b.nombre.includes("ISO")) return -1;
                                    if (a.nombre.includes("Machine Learning")) return 1;
                                    if (b.nombre.includes("Machine Learning")) return -1;
                                    return 0;
                                })
                                .map((tech, idx) => {
                                    const isIso = tech.nombre.includes("ISO");
                                    const isML = tech.nombre.includes("Machine Learning");
                                    const needsEnlarge = [
                                        "Java", "PyTorch", "Kafka", "OCI", "Artificial Intelligence", "Python"
                                    ].includes(tech.nombre);
                                    
                                    const needsExtraEnlarge = [
                                        "Spring Boot", "Google Cloud", "MongoDB", 
                                        "Google Pub/Sub", "TensorFlow", "SonarQube", "Node.js"
                                    ].includes(tech.nombre);

                                    const techClass = tech.nombre.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '');
                                    
                                    return (
                                        <div key={idx} className={`logo-item-box ${isIso ? 'iso-badge-box' : ''} tech-${techClass}`}>
                                            <div className="logo-img-container">
                                                <img 
                                                    src={tech.logo} 
                                                    alt={tech.nombre} 
                                                    className={needsExtraEnlarge ? 'img-extra-large' : needsEnlarge ? 'img-large' : ''}
                                                />
                                            </div>
                                            <span className="nombre-tecnologia">{isIso ? `Certificación ${tech.nombre}` : tech.nombre}</span>
                                        </div>
                                    );
                                })}
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Tecnologias;
